import { render, staticRenderFns } from "./ImportApproval.vue?vue&type=template&id=47159a03&scoped=true"
import script from "./ImportApproval.vue?vue&type=script&lang=js"
export * from "./ImportApproval.vue?vue&type=script&lang=js"
import style0 from "./ImportApproval.vue?vue&type=style&index=0&id=47159a03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47159a03",
  null
  
)

export default component.exports